import { useMemo } from 'react';

import { useIntl } from '@atlassian/jira-intl';

import { MENU_ITEMS } from './constants';
import type { SettingsLink } from './types';

export const useMenuItems = (isJsm: boolean, isUserLocatedBoard: boolean): SettingsLink[] => {
	const { formatMessage } = useIntl();

	return useMemo(
		() =>
			MENU_ITEMS.flatMap((item) =>
				(item.jsmAllowed || !isJsm) && (item.userLocatedBoardAllowed || !isUserLocatedBoard)
					? [{ ...item, name: formatMessage(item.name) }]
					: [],
			),
		[formatMessage, isJsm, isUserLocatedBoard],
	);
};
